import { render, staticRenderFns } from "./appcustomers-add-or-update.vue?vue&type=template&id=bfd51290&"
import script from "./appcustomers-add-or-update.vue?vue&type=script&lang=js&"
export * from "./appcustomers-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports